import axios from "axios";
export default {
    saveAccessLevel: (accessLevel) => axios.post("/AccessLevels/SaveLevel", accessLevel),
    deleteAccessLevel: (accessLevel) => axios.post("/AccessLevels/DeleteLevel", accessLevel)
};
